import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { QuestionnaireRunner } from "@/components/study/QuestionnaireRunner";
import { canAnswerWave, useStudyStore } from "@/lib/stores/studyStore";
import type { StudyWave } from "@/lib/types/study";

const paramsSchema = z.object({
  wave: z.enum(["t0", "t1", "t2"]),
});

export const Route = createFileRoute("/(content)/study/$wave")({
  component: StudyWaveComponent,
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: (p) => ({ wave: p.wave }),
  },
  head: () => ({ meta: [{ title: "Questionnaire - HAMD" }] }),
  beforeLoad: () => ({
    title: "study.efficacy.title",
    navbar: { showTitle: true, onBack: false },
  }),
});

function StudyWaveComponent() {
  const navigate = useNavigate();
  const { wave: waveParam } = Route.useParams();
  const wave = waveParam.toUpperCase() as StudyWave;
  const status = useStudyStore((s) => s.status);
  const hasFetched = useStudyStore((s) => s.hasFetched);

  useEffect(() => {
    if (!hasFetched || canAnswerWave(status, wave)) return;
    navigate({ to: status ? "/adults/exercises" : "/study" });
  }, [status, hasFetched, wave, navigate]);

  if (!hasFetched || !canAnswerWave(status, wave)) return null;

  return <QuestionnaireRunner wave={wave} />;
}
